import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';

const LandingNetworkStyled = styled.section``;

function LandingNetwork() {
    const { getLangPath } = useLangContext();

    return (
        <LandingNetworkStyled className="block network" id="network">
            <div className="wrap">
                <div className="kicker" id="sub-affiliate-section-label">{getLangPath('landing.network.kicker')}</div>
                <div className="network-grid">
                    <div className="network-copy">
                        <h2>
                            {getLangPath('landing.network.titleLine1')}
                            <br/>
                            {getLangPath('landing.network.titleLine2')}
                        </h2>
                        <div className="override">
                            <div className="network-rate-line">
                                <span>15%</span>
                                <span className="network-founder-badge">
                                    <strong>{getLangPath('landing.network.limited')}</strong>
                                    <span>{getLangPath('landing.network.founders')}</span>
                                </span>
                            </div>
                            <small>{getLangPath('landing.network.founderText')}</small>
                        </div>
                    </div>
                    <div className="network-right">
                        <div className="flow">
                            <div className="flow-row">
                                <div>
                                    <span>{getLangPath('landing.network.earns')}</span>
                                    <br/>
                                    <strong>$1,000</strong>
                                </div>
                                <div>
                                    <span>{getLangPath('landing.network.keep')}</span>
                                    <br/>
                                    <strong>$1,000</strong>
                                </div>
                            </div>
                            <div className="flow-divider"><span>↓</span></div>
                            <div className="flow-row">
                                <div>
                                    <span>{getLangPath('landing.network.override')}</span>
                                    <br/>
                                    <strong>{getLangPath('landing.network.separately')}</strong>
                                </div>
                                <div className="you">+$150</div>
                            </div>
                            <p>{getLangPath('landing.network.note')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </LandingNetworkStyled>
    );
}

export default LandingNetwork;
